<template>
<!-- ブラウザバック時の表示 -->
<div v-if="!katudom.bosyu_id" id="content">
	<div class="content-blk">
		<p>エラーが発生しました。トップへ戻ってください。</p>
			<div class="center">
				<router-link to="/"><button class="btn_on">検索画面へ戻る</button></router-link>
			</div>
	</div>
</div>
<div v-else id="content">
<!-- ページ内ヘッダ -->
	<div class="center mosi_pan">
		<p>【申込までの流れ】</p>
		<ul class="pankuzu">
			<li>活動選択</li>
			<li>申込理由/活動日程選択</li>
			<li class="selected">内容確認</li>
			<!-- <li>申込完了</li> -->
		</ul>
	</div>
	<div id="mosikomi" class="content-blk">
		<!-- <p class="warn_red">※ 申込完了まであと少しです。</p> -->
		<p class="center">以下の内容でよろしいですか？<br>※変更したい場合は下の戻るボタンより修正できます。<br><span class="warn_red">ブラウザの戻るボタンは使用しないでください。</span></p>
			<div class="point_box">
				<span class="box-title">POINT</span>
				<div class="point_detail">
					<div>
						<fa icon="exclamation-circle" class="icon fa-fw" /><span class="point_title">申込内容について</span>
					</div>
					<div>
						<p class="point_text">必要な方はPDF・スクリーンショット等で保存してください。</p>
					</div>
					<div>
						<div class="point_text btn_download" @click="print"><fa icon="download" class="icon far fa-angle-double-down fa-fw" />印刷・PDF出力</div>
					</div>
				</div>
			</div>
		<!-- 内容確認 -->
		<div class="inner">
			<h2>ボランティア情報</h2>
			<table class="table_confirm">
				<tr><td width="30%">施設名</td><td>{{bosyu_naiyo.sisetu_name}}</td></tr>
				<tr><td>活動内容</td><td class="kaigyo">{{ bosyu_naiyo.naiyou }}</td></tr>
				<tr v-if="bosyu_naiyo.henkonaiyo"><td>変更内容</td><td class="kaigyo">{{ bosyu_naiyo.henkonaiyo }}</td></tr>
				<tr><td>活動場所</td>
					<td class="kaigyo">〒{{bosyu_naiyo.zipcode}}<br>{{ bosyu_naiyo.address }}<br><fa icon="phone" class="icon" />{{bosyu_naiyo.tel}}<br>{{bosyu_naiyo.kotukikan}}</td>
				</tr>
				<tr><td>活動分野</td>
					<td><ul class="bunya_list">
						<li v-if="bosyu_naiyo.katudo_bunya_id === 1" class="korei_icon"><span class="bunya_text">高齢者関係</span></li>
						<li v-if="bosyu_naiyo.katudo_bunya_id === 2" class="syogai_icon"><span class="bunya_text">障がい児・者関係</span></li>
						<li v-if="bosyu_naiyo.katudo_bunya_id === 3" class="jido_icon"><span class="bunya_text">児童関係</span></li>
						<li v-if="bosyu_naiyo.katudo_bunya_id === 4" class="hoken_icon"><span class="bunya_text">保健・医療関係</span></li>
						<li v-if="bosyu_naiyo.katudo_bunya_id === 5" class="sonota_icon"><span class="bunya_text">その他</span></li>
					</ul></td>
				</tr>
				<tr><td>募集中ボランティア</td>
					<td>
						<ul class="flex ukeire_box">
							<li><span class="ukeire ukeire_syogaku" v-if="bosyu_naiyo.uke_syogaku_check === 1">小</span></li>
							<li><span class="ukeire ukeire_cyugaku" v-if="bosyu_naiyo.uke_cyugaku_check === 1">中</span></li>
							<li><span class="ukeire ukeire_koko" v-if="bosyu_naiyo.uke_koko_check === 1">高</span></li>
							<li><span class="ukeire ukeire_tansen" v-if="bosyu_naiyo.uke_tansen_check === 1">短</span></li>
							<li><span class="ukeire ukeire_daigaku" v-if="bosyu_naiyo.uke_daigaku_check === 1">大</span></li>
							<li><span class="ukeire ukeire_syuhu" v-if="bosyu_naiyo.uke_syuhu_check === 1">主</span></li>
							<li><span class="ukeire ukeire_kaisya" v-if="bosyu_naiyo.uke_kaisya_check === 1">会</span></li>
							<li><span class="ukeire ukeire_korei" v-if="bosyu_naiyo.uke_korei_check === 1">齢</span></li>
							<li><span class="ukeire ukeire_syogai" v-if="bosyu_naiyo.uke_syogai_check === 1">障</span></li>
						</ul>
					</td>
				</tr>
				<tr v-if="bosyu_naiyo.pr"><td>活動先からのメッセージ</td><td class="kaigyo">{{ bosyu_naiyo.pr }}</td></tr>
				<tr v-if="bosyu_naiyo.tyuijiko"><td>注意事項</td><td class="kaigyo">{{ bosyu_naiyo.tyuijiko }}</td></tr>
			</table>
			<h2>自分の情報</h2>
			<table class="table_confirm">
				<tr>
					<td width="30%">自分の情報</td>
					<td>
						<ul class="ukeire_box">
							<li v-if="katudom.kaiso === '1'"><span class="ukeire ukeire_syogaku">小</span>小学生</li>
							<li v-if="katudom.kaiso === '2'"><span class="ukeire ukeire_cyugaku">中</span>中学生</li>
							<li v-if="katudom.kaiso === '3'"><span class="ukeire ukeire_koko">高</span>高校生</li>
							<li v-if="katudom.kaiso === '4'"><span class="ukeire ukeire_tansen">短</span>短大・専門学生</li>
							<li v-if="katudom.kaiso === '5'"><span class="ukeire ukeire_daigaku">大</span>大学生</li>
							<li v-if="katudom.kaiso === '6'"><span class="ukeire ukeire_syuhu">主</span>主婦/主夫</li>
							<li v-if="katudom.kaiso === '7'"><span class="ukeire ukeire_kaisya">会</span>会社員</li>
							<li v-if="katudom.kaiso === '8'"><span class="ukeire ukeire_korei">齢</span>高齢者</li>
							<li v-if="katudom.kaiso === '9'"><span class="ukeire ukeire_syogai">障</span>障がい者</li>
						</ul>
					</td>
				</tr>
			</table>
			<h2>申込日程</h2>
			<table class="table_confirm">
				<tr>
					<td width="30%">申込日程</td>
					<td><p v-for="nt in Nittei" :key="nt.num">{{nt.date}}</p></td>
				</tr>
			</table>
			<h2>活動先を選んだ理由</h2>
			<table class="table_confirm">
				<tr><td width="30%">選択理由</td><td><p v-if="katudom.reason1 === '1'">居住地に近い</p><p v-if="katudom.reason2 === '1'">活動内容が魅力的</p><p v-if="katudom.reason3 === '1'">通勤・通学等交通の便がよい</p><p v-if="katudom.reason4 === '1'">活動期間</p><p v-if="katudom.reason5 === '1'">友人・知人が行くので</p><p v-if="katudom.reason6 === '1'">その他：<span v-if="katudom.sonota">{{katudom.sonota}}</span><span v-else>（入力されていません）</span></p></td></tr>
			</table>
		</div>
		<div class="flex justifycont-c center buttons">
			<router-link :to="{ name: 'KatudoMosikomi', params: { value: katudom.bosyu_id }}"><button class="btn_cancel">戻る</button></router-link>
			<button @click="onSubmit" class="btn_on">申し込む</button>
			<!-- <button class="btn_off" @click="print">PDFで保存</button> -->
		</div>
	</div>
	<!-- <div>
		<router-link :to="{ name: 'KatudoMosikomi', params: { value: katudom.bosyu_id }}"><button class="btn_cancel">戻る</button></router-link>
		<button @click="onSubmit" class="btn_apply">申込</button>
		<button class="btn_new" @click="print">PDFで保存</button>
	</div> -->
</div>
</template>

<script>
import { inject } from 'vue';
import { format } from 'date-fns'
import ja from 'date-fns/locale/ja'
// import router from '../router';
import axios from 'axios';
export default {
	name: 'KatsudoMosikomiConfirm',
	components: {
	},
	setup() {
		const { katudom, register } = inject('kmosikomi');
		const { login } = inject('loginstate');
		return {
			katudom,
			register,
			format,
			ja,
			login,
		};
	},
	data() {
		return {
			// katudom: {},
			bosyu_naiyo: [],
			Nittei: [],

		};
	},
	async created() {
		// 募集要項情報
		let res2 = await axios.get('/api/bosyu_data/info?id='+ this.katudom.bosyu_id)
		// console.log(res2.data)
		this.bosyu_naiyo = res2.data

		// 施設情報
		let res3 = await axios.get('/api/sisetu_data/info?id='+ this.bosyu_naiyo.sisetu_id)
		// console.log(res3.data)
		this.bosyu_naiyo.sisetu_name = res3.data.sisetu_name
		this.bosyu_naiyo.tel = res3.data.tel

		// 日付の加工（katudom.nittei）
		const LENG = this.katudom.nittei.length;
		for(var i = 0; i < LENG; i++) {
			let NIT = new Date(this.katudom.nittei[i]);
			NIT = NIT.getFullYear() + "年" + (NIT.getMonth() + 1) + "月" + NIT.getDate() + "日";
			this.Nittei.push(
				{
					"num": i,
					"date": NIT
				}
			)
		}
		console.log(this.Nittei)

	},
	methods: {
		onSubmit() {
			// 登録処理
			this.register(this.login.id);
			// router.push({ path: '/katudo-mosikomi/registered'});
		},
		print() {
			// 登録処理（追記）
			window.print();
		},
	},
}
</script>